import React, { useState } from "react"
import { connectSearchBox } from "react-instantsearch-dom"
import { SearchIcon } from '@heroicons/react/solid'

export default connectSearchBox(
    ({ refine, currentRefinement, className, onFocus }) => {

      let timerId = null
      const delay = 1000

      const [newRefinement, setNewRefinement] = useState(currentRefinement)

      const onChangeDebounced = (event) => {
        const value = event.currentTarget.value
    
        clearTimeout(timerId)
        timerId = setTimeout(() => refine(value), delay)
    
        setNewRefinement(value)
    
      }

      return (
        <form className={className} onSubmit={e => { e.preventDefault(); }}>
          <div className="absolute inset-y-0 left-0 px-6 flex items-center pointer-events-none">
            <SearchIcon className="h-6 w-6 text-[#C7C7C7] -mt-1" aria-hidden="true" />
          </div>
          <input
            className="block w-full mx-auto font-display leading-none bg-[#F5F5F5] py-6 pr-8 pl-16 text-darkgrey border-0 focus:outline-none text-2xl placeholder-[#C7C7C7] ring-0 focus:ring-0"
            type="text"
            placeholder="What do you want to search for?"
            aria-label="Search"
            onChange={e => onChangeDebounced(e)}
            value={newRefinement}
            onFocus={onFocus}
          />
        </form>
      )
    }
)